import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AdminProtectedRoute from "./pages/AdminProtectedRoute";
import StaffLogin from "./pages/AdminLogin";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<StaffLogin />} />
        {/* All staff roles use the same admin panel */}
        <Route path="/admin/*" element={<AdminProtectedRoute />} />
        <Route path="/employee/*" element={<AdminProtectedRoute />} />
        <Route path="/superadmin/*" element={<AdminProtectedRoute />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;